var _circle, _path, _path2, _rect, _path3, _ellipse, _rect2, _path4, _rect3, _rect4, _rect5, _rect6, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmusementParkTrainGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#F1F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5172 21.418C44.8191 20.6852 42.8359 18.233 42.8359 15.3207C42.8359 11.8299 45.6851 9 49.1998 9C52.2443 9 54.7893 11.1232 55.4159 13.9601C55.4934 13.9561 55.5713 13.954 55.6497 13.954C58.072 13.954 60.0357 15.9043 60.0357 18.3102C60.0357 20.5723 58.2996 22.4317 56.0785 22.6458C56.0793 22.681 56.0797 22.7163 56.0797 22.7517C56.0797 25.1575 54.1161 27.1078 51.6938 27.1078C49.2715 27.1078 47.3079 25.1575 47.3079 22.7517C47.3079 22.2865 47.3813 21.8384 47.5172 21.418Z",
    fill: "#D5D8DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3076 28.3037H56.5955L56.0795 36.1618H47.9956L47.3076 28.3037Z",
    fill: "#505862"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.39453,
    y: 54.9626,
    width: 56.2871,
    height: 6.3891,
    fill: "#505862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1799 64.7937L65.3551 55.6225C65.2253 55.4876 65.0462 55.4114 64.8591 55.4114H60.0598C59.6796 55.4114 59.3713 55.7196 59.3713 56.0998V65.271C59.3713 65.6512 59.6796 65.9594 60.0598 65.9594H73.6839C74.2908 65.9594 74.6008 65.231 74.1799 64.7937Z",
    fill: "#505862"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.5575,
    cy: 46.4454,
    rx: 10.0206,
    ry: 9.55818,
    transform: "rotate(90 62.5575 46.4454)",
    fill: "#9DA4AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.9451,
    y: 36.4248,
    width: 28.6745,
    height: 20.0413,
    fill: "#B9BEC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 24.822H36.007V56.4662H8.39453L8.39453 52.7836C8.39453 50.7409 10.0505 49.0849 12.0932 49.0849H12.9167V40.6441V24.822Z",
    fill: "#9DA4AF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1885,
    y: 23.0081,
    width: 26.4876,
    height: 2.73326,
    rx: 0.809765,
    fill: "#505862"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8289,
    y: 27.9866,
    width: 16.9923,
    height: 14.7673,
    rx: 0.809765,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8005,
    y: 44.7031,
    width: 5.50391,
    height: 1.70829,
    rx: 0.809765,
    fill: "#505862"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.9561,
    y: 38.0408,
    width: 27.6916,
    height: 5.46652,
    fill: "#D5D8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4081 56.9174C33.4081 61.7836 29.4344 65.74 24.5183 65.74C19.6021 65.74 15.6284 61.7836 15.6284 56.9174C15.6284 52.0512 19.6021 48.0947 24.5183 48.0947C29.4344 48.0947 33.4081 52.0512 33.4081 56.9174Z",
    fill: "#B9BEC6",
    stroke: "#505862",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.681 60.3326C47.681 63.3111 45.2481 65.7372 42.2326 65.7372C39.2171 65.7372 36.7842 63.3111 36.7842 60.3326C36.7842 57.3541 39.2171 54.928 42.2326 54.928C45.2481 54.928 47.681 57.3541 47.681 60.3326Z",
    fill: "#B9BEC6",
    stroke: "#505862",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3034 60.3326C62.3034 63.3111 59.8705 65.7372 56.8549 65.7372C53.8394 65.7372 51.4065 63.3111 51.4065 60.3326C51.4065 57.3541 53.8394 54.928 56.8549 54.928C59.8705 54.928 62.3034 57.3541 62.3034 60.3326Z",
    fill: "#B9BEC6",
    stroke: "#505862",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7431 26.6901C46.7713 26.5363 46.9054 26.4246 47.0617 26.4246H56.8416C56.998 26.4246 57.132 26.5363 57.1602 26.6901L57.3856 27.9214C57.422 28.1204 57.2692 28.3037 57.067 28.3037H46.8363C46.6341 28.3037 46.4813 28.1204 46.5177 27.9214L46.7431 26.6901Z",
    fill: "#505862"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmusementParkTrainGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AmusementParkTrainGray.d39a2aca743f5d4219e5161bf64a241a.svg";